import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.4_@babel+core@7.26.10_@playwright+test@1.51.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AudioPlayer"] */ "/app/src/components/ui/audio-player/audio-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AutoRedirectBlock"] */ "/app/src/components/ui/auto-redirect-block.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/nav-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OverlayMenuToggle"] */ "/app/src/components/ui/navigation/overlay-menu-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OverlayMenuItem"] */ "/app/src/components/ui/overlay-menu/overlay-menu-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/ThemeToggleButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyLink"] */ "/app/src/features/legal/privacy-policy-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TermsOfServiceLink"] */ "/app/src/features/legal/terms-of-service-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleLocaleButton"] */ "/app/src/features/locale/toggle-locale-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/navigation/OverlayContainer.tsx");
